module.exports = __webpack_public_path__ + "static/media/golden_chip_roulette.yggdrasil.a83ef992.jpeg";